const languages = [
  { name: "Assamese", value: "as" },
  { name: "Bengali", value: "bn" },
  { name: "English", value: "en" },
  { name: "Gujarati", value: "gu" },
  { name: "Hindi", value: "hi" },
  { name: "Kannada", value: "kn" },
  { name: "Malayalam", value: "ml" },
  { name: "Marathi", value: "mr" },
  { name: "Odia", value: "or" },
  { name: "Punjabi", value: "pa" },
  { name: "Tamil", value: "ta" },
  { name: "Telugu", value: "te" },
  { name: "Urdu", value: "ur" },
  { name: "Arabic", value: "ar" },
  { name: "Chinese", value: "zh-Hans" },
  { name: "French", value: "fr" },
  { name: "German", value: "de" },
  { name: "Italian", value: "it" },
  { name: "Japanese", value: "ja" },
  { name: "Korean", value: "ko" },
  { name: "Malay", value: "ms" },
  { name: "Persian", value: "fa" },
  { name: "Portuguese", value: "pt" },
  { name: "Russian", value: "ru" },
  { name: "Spanish", value: "es" },
  { name: "Turkish ", value: "tr" },
  { name: "Urdu", value: "ur" },
  { name: "Vietnamese", value: "vi" },
  { name: "Thai", value: "th" },
  { name: "Hebrew", value: "he" },
  { name: "Swedish", value: "sv" },
  { name: "Dutch", value: "nl" },
  { name: "Pashto", value: "ps" },
];
const Indianlanguages = [
  { name: "Assamese", value: "as" },
  { name: "Bengali", value: "bn" },
  { name: "English", value: "en" },
  { name: "Gujarati", value: "gu" },
  { name: "Hindi", value: "hi" },
  { name: "Kannada", value: "kn" },
  { name: "Malayalam", value: "ml" },
  { name: "Marathi", value: "mr" },
  { name: "Odia", value: "or" },
  { name: "Punjabi", value: "pa" },
  { name: "Tamil", value: "ta" },
  { name: "Telugu", value: "te" },
  { name: "Urdu", value: "ur" },
  { name: "Arabic", value: "ar" },
  { name: "Chinese", value: "zh" },
  { name: "French", value: "fr" },
  { name: "German", value: "de" },
  { name: "Italian", value: "it" },
  { name: "Japanese", value: "ja" },
  { name: "Korean", value: "ko" },
  { name: "Malay", value: "ms" },
  { name: "Persian", value: "fa" },
  { name: "Portuguese", value: "pt" },
  { name: "Russian", value: "ru" },
  { name: "Spanish", value: "es" },
  { name: "Turkish ", value: "tr" },
  { name: "Urdu", value: "ur" },
  { name: "Vietnamese", value: "vi" },
  { name: "Thai", value: "th" },
  { name: "Hebrew", value: "he" },
  { name: "Swedish", value: "sv" },
  { name: "Dutch", value: "nl" },
  { name: "Pashto", value: "ps" },
];

const ocr_languages = [
  { name: "Assamese", value: "as" },
  { name: "Bengali", value: "bn" },
  { name: "English", value: "en" },
  { name: "Gujarati", value: "gu" },
  { name: "Hindi", value: "hi" },
  { name: "Malayalam", value: "ml" },
  { name: "Marathi", value: "mr" },
  { name: "Odia", value: "or" },
  { name: "Punjabi", value: "pa" },
  { name: "Tamil", value: "ta" },
  { name: "Telugu", value: "te" },
  { name: "Urdu", value: "ur" },
  { name: "nepali", value: "nep" },
  // { name: 'Pashto', value: 'ps' }
];

export { languages, Indianlanguages, ocr_languages };
